<template>
  <PageLoader :loading="loading">
    <ShopPage />
  </PageLoader>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { salesApi } from "@/services/sales-api";
import { usePlatformApi } from "@/services/platform-api";
import PageLoader from "@/components/pages/PageLoader";
import ShopPage from "@/components/pages/shop";

export default defineComponent({
  components: { PageLoader, ShopPage },
  setup() {
    definePageMeta({
      layout: "anonymous",
      disableHeaderStick: true,
    });
    const route = useRoute();
    const api = usePlatformApi();
    const sales = salesApi();
    const store = useShopProfileStore();

    const { loading, handle, onResult } = observeAsync(api.shopProfiles.find);

    handle({
      id: String(route.params.payload || ""),
      token: String(route.query.token || ""),
    });

    onResult((data) => {
      store.updateWithProfile(data.profile);
      sales.client.setPublishableKey(data.pk.token);
    });

    // reset publishable key to marketplace's default before leaving page
    // onBeforeRouteUpdate(sales.resetPublishableKey);

    return {
      loading,
    };
  },
});
</script>
